<template>
  <div class="sidebar pointer">
    <div class="sidebar-item" @click="toReport">
      <el-image :src="reportSrc" fit="cover"></el-image>
      <div class="sidebar-item-text">报告验证</div>
    </div>
    <div class="sidebar-item" @click="toOnlineConsult">
      <el-image :src="onlineConsultSrc" fit="cover"></el-image>
      <div class="sidebar-item-text">在线留言</div>
    </div>

    <!--在线留言对话框-->
    <OnlineConsultDialog v-model="showOnlineConsulDialog" />
  </div>
</template>

<script>
import OnlineConsultDialog from "./OnlineConsult/index.vue";

export default {
  components: {
    OnlineConsultDialog,
  },
  props: {},
  data() {
    return {
      //报告验证
      reportSrc: require("@/assets/common/report.png"),
      //在线留言
      showOnlineConsulDialog: false,
      onlineConsultSrc: require("@/assets/common/onlineConsult.png"),
    };
  },
  methods: {
    toReport() {
      window.open(
        "http://www.xn--ruq948cu5a6yj.cn/entrust/lodingEntrust",
        "_blank"
      );
    },
    toOnlineConsult() {
      this.showOnlineConsulDialog = true;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.sidebar {
  position: fixed;
  bottom: 150px;
  right: 6px;
  width: 64px;
  background: #eafbfd;
  z-index: 999;
  box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
  border-radius: 4px;
  font-size: 20px;
  text-align: center;
  &-item {
    &-text {
      padding: 0 10px 8px 10px;
    }
  }
}
</style>
